<template>
  <div>
    <enable-disable-reply
      v-model="enabled"
      @fetched="fetched=$event"
    />
    <bot-reply-form
      v-if="fetched && enabled"
      keyword="story-mention"
      :is-direct="currentPage.is_direct"
      :account-id="currentPage.id"
    />
  </div>
</template>

<script>

import BotReplyForm from '@/views/owner-instagram/bot/BotReplyForm'
import EnableDisableReply from '@/views/owner-instagram/bot/EnableDisableReply'
import { mapGetters } from 'vuex'

export default {
  name: 'StoryMentionReply',
  components: { EnableDisableReply, BotReplyForm },
  data() {
    return {
      enabled: false,
      fetched: false,
    }
  },
  computed: {
    ...mapGetters({
      currentPage: 'instagram/currentAccount',
    }),
  },
}
</script>
